import { render, staticRenderFns } from "./p06.vue?vue&type=template&id=98e30b94&scoped=true&"
import script from "./p06.vue?vue&type=script&lang=js&"
export * from "./p06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e30b94",
  null
  
)

export default component.exports